import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaStar, FaLongArrowAltRight } from "react-icons/fa";
import c1 from "../asset/carousel/f1.png";
import c2 from "../asset/carousel/f2.png";
import c3 from "../asset/carousel/f3.png";
import m1 from "../asset/carousel/c1.png";
import m2 from "../asset/carousel/c2.png";
import m3 from "../asset/carousel/c3.png";
import t1 from "../asset/carousel/t1.png";
import t2 from "../asset/carousel/t2.png";
import t3 from "../asset/carousel/t3.png";
import SummaryApi from "../common";
import { useNavigate } from "react-router-dom";
import noimage from "../asset/noimage.png";

const CourseCard = ({
  id,
  title,
  rating,
  students,
  modules,
  discount,
  price,
  image,
}) => {
  const navigate = useNavigate();
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md dark:shadow-gray-700 overflow-hidden transform transition-transform duration-300 hover:scale-105 flex flex-col border border-gray-200 dark:border-gray-700">
      <img
        className="w-full h-48 object-cover"
        src={image || noimage}
        alt={title}
      />
      <div className="p-4 flex flex-col flex-grow">
        <h4 className="font-semibold text-sm line-clamp-2 min-h-[25px] text-gray-800 dark:text-white">
          {title}
        </h4>
        <div className="flex items-center text-[15px] text-gray-600 dark:text-gray-400 mb-1">
          <span className="flex items-center">
            <span className="text-[#E4DC4C] dark:text-yellow-400 mr-1">
              <FaStar />
            </span>
            {rating}
          </span>
          <span className="ml-2">({students})</span>
        </div>
        <div className="flex justify-between items-center mb-4">
          <span className="text-green-600 dark:text-green-400 text-[12px] font-medium">
            {discount}% off
          </span>
        </div>
        <div className="mt-auto">
          <button
            className="w-full bg-[#1C3664] hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 text-white text-[12px] py-1 rounded transition-colors"
            onClick={() => {
              const encodedId = btoa(id.toString());
              navigate(`/all-courses/${encodedId}`);
            }}
          >
            Details
          </button>
        </div>
      </div>
    </div>
  );
};

const Carousel = () => {
  const [courses, setCourses] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await fetch(SummaryApi.getActiveCarrerCourses.url);
        const data = await res.json();
        if (data.status && Array.isArray(data.data)) {
          const firstFour = data.data.slice(0, 4);
          setCourses(firstFour);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);

  const mapCourseData = (course) => ({
    id: course.course_id,
    title: course.course_title,
    rating: parseFloat(course.rating) || 0,
    students: course.total_student_enrolled_count,
    modules: parseInt(course.total_lessions) || 0,
    discount: course.discount,
    price: course.total_price,
    image: course.course_image1
      ? `${SummaryApi.instructorCourseImage.url.replace("api", "")}${course.course_image1.replace("/api", "")}`
      : noimage,
  });

  const courseCards = courses.map(mapCourseData);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  const slides = [
    {
      id: 1,
      headingBold: "Expertise",
      headingRest: `You bring the , we'll make it unforgettable.`,
      text: `Unlock your potential with our comprehensive educational platform—designed to inspire, engage, and equip learners.`,
      button1Text: "Get Started",
      button2Text: "Buy Course",
      image: c1,
      mobileImage: m1,
      tabletImage: t1, // Added tablet image
    },
    {
      id: 2,
      headingBold: "Transform Your Future Through Online Learning",
      headingRest: "",
      text: `Unlock your potential with world-class online courses.`,
      button1Text: "Enroll",
      button2Text: "Buy Course",
      image: c2,
      mobileImage: m2,
      tabletImage: t2, // Added tablet image
    },
    {
      id: 3,
      headingBold: "Skills",
      headingRest: `Up Your To Advance Your Career Path`,
      text: `Empower your career with expert-led online programs.`,
      button1Text: "Get Started",
      button2Text: "Buy Course",
      image: c3,
      mobileImage: m3,
      tabletImage: t3, // Added tablet image
    },
  ];

  return (
    <div className="relative">
      <div className="relative flex items-center justify-center py-">
        <Slider {...settings} className="w-full mx-auto">
          {slides.map((slide) => (
            <div key={slide.id} className="px-4">
              {/* Desktop ONLY (1024px and above) → Original background layout */}
              <div className="hidden lg:block">
                <div
                  className="flex flex-col lg:flex-row items-center justify-between rounded-xl overflow-hidden min-h-[600px] bg-cover bg-center relative"
                  style={{ backgroundImage: `url(${slide.image})` }}
                >
                  <div className="relative lg:w-[60%] p-8 md:p-12 lg:p-16 flex flex-col justify-center z-10">
                    <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-6 text-white font-inter">
                      <span className="text-blue-400">{slide.headingBold}</span>{" "}
                      {slide.headingRest &&
                        slide.headingRest.split(" ").map((word, index) => (
                          <span
                            key={index}
                            className={
                              ["expertise", "skills", "advance", "career"].includes(
                                word.toLowerCase()
                              )
                                ? "text-blue-400"
                                : "text-[#1C3664]"
                            }
                          >   
                            {word}{" "}
                          </span>
                        ))}
                    </h1>
                    <p className="text-lg mb-8 max-w-md text-black">{slide.text}</p>
                    <div className="flex space-x-4 mb-12">
                      <a
                        href="/all-courses"
                        className="flex items-center bg-[#1C3664] hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition-colors"
                      >
                        {slide.button1Text}
                        <FaLongArrowAltRight className="ml-2" />
                      </a>
                      <button className="bg-[#1C3664] hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg shadow-md transition-colors">
                        {slide.button2Text}
                      </button>
                    </div>

                    {/* Course Cards - Desktop */}
                    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4">
                      {courseCards.length > 0 ? (
                        courseCards.map((card, idx) => (
                          <CourseCard key={idx} {...card} />
                        ))
                      ) : (
                        <p className="text-white">Loading courses...</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Tablet & Mobile (below 1024px) */}
              <div className="block lg:hidden">
                {/* Tablet View (md and above) - Image and text side-by-side */}
                <div 
                  className="hidden md:flex flex-row items-center justify-between rounded-xl overflow-hidden min-h-[400px] bg-cover bg-center relative"
                  style={{ backgroundImage: `url(${slide.tabletImage})` }} 
                >
                  <div className="relative w-1/2 p-6 flex flex-col justify-center z-10">
                    <h1 className="text-2xl font-extrabold leading-tight mb-4 text-white font-inter">
                      <span className="text-blue-400">{slide.headingBold}</span>{" "}
                      {slide.headingRest &&
                        slide.headingRest.split(" ").map((word, index) => (
                          <span
                            key={index}
                            className={
                              ["expertise", "skills", "advance", "career"].includes(
                                word.toLowerCase()
                              )
                                ? "text-blue-400"
                                : "text-[#1C3664]"
                            }
                          >   
                            {word}{" "}
                          </span>
                        ))}
                    </h1>
                    <p className="text-base mb-6 max-w-sm text-black">{slide.text}</p>
                    <div className="flex space-x-4 mb-8">
                      <a
                        href="/all-courses"
                        className="flex items-center bg-[#1C3664] hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg shadow-md transition-colors text-sm"
                      >
                        {slide.button1Text}
                        <FaLongArrowAltRight className="ml-2" />
                      </a>
                      <button className="bg-[#1C3664] hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition-colors text-sm">
                        {slide.button2Text}
                      </button>
                    </div>

                    {/* Course Cards - Tablet */}
                    <div className="grid grid-cols-2 gap-4">
                      {courseCards.length > 0 ? (
                        courseCards.slice(0, 2).map((card, idx) => ( // Show 2 cards on tablet
                          <CourseCard key={idx} {...card} />
                        ))
                      ) : (
                        <p className="text-white">Loading courses...</p>
                      )}
                    </div>
                  </div>
                  {/* Empty div for the image to take up space on the right, as it's a background image */}
                  <div className="w-1/2 h-full"></div> 
                </div>

          <div className="block md:hidden -mt-6 -mx-4 pt-6">
                  <div className="flex flex-col bg-white dark:bg-gray-900  overflow-hidden shadow-lg">
                    {/* Hero Image - Mobile version - Full image display */}
                    <div className="w-full h-64"> {/* Reduced height for mobile */}
                      <img
                        src={slide.mobileImage}
                        alt="Hero"
                        className="w-full h-full object-contain object-top"
                      />
                    </div>

                    {/* Content on White Background */}
                    <div className="p-4 flex flex-col flex-grow"> {/* Reduced padding for mobile */}
                      <h1 className="text-xl font-extrabold leading-tight mb-3 text-gray-900 dark:text-white"> {/* Smaller font for mobile */}
                        <span className="text-blue-600">{slide.headingBold}</span>{" "}
                        {slide.headingRest &&
                          slide.headingRest.split(" ").map((word, index) => (
                            <span
                              key={index}
                              className={
                                ["expertise", "skills", "advance", "career"].includes(
                                  word.toLowerCase()
                                )
                                  ? "text-blue-600"
                                  : "text-[]"
                              }
                            >
                              {word}{" "}
                            </span>
                          ))}
                      </h1>
                      <p className="text-sm mb-4 text-gray-700 dark:text-gray-300"> {/* Smaller font for mobile */}
                        {slide.text}
                      </p>

                      {/* Buttons in a row on mobile */}
                      <div className="flex flex-row flex-wrap gap-2 mb-4 justify-center"> {/* Smaller gap for mobile */}
                        <a
                          href="/all-courses"
                          className="flex justify-center items-center bg-[#1C3664] hover:bg-blue-800 text-white font-semibold py-1 px-3 rounded-lg shadow-md transition-colors whitespace-nowrap text-xs" // Smaller buttons for mobile
                        >
                          {slide.button1Text}
                          <FaLongArrowAltRight className="ml-1 text-xs" /> {/* Smaller icon for mobile */}
                        </a>
                        <button className="bg-[#1C3664] hover:bg-blue-800 text-white font-semibold py-1 px-3 rounded-lg shadow-md transition-colors whitespace-nowrap text-xs"> {/* Smaller buttons for mobile */}
                          {slide.button2Text}
                        </button>
                      </div>

                      {/* Mobile Course Cards */}
                      <div className="grid grid-cols-1 gap-3"> {/* Smaller gap for mobile */}
                        {courseCards.length > 0 ? (
                          courseCards.map((card, idx) => (
                            <CourseCard key={idx} {...card} />
                          ))
                        ) : (
                          <p className="text-gray-600 text-center text-sm">Loading courses...</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Carousel;